import { system } from 'styled-system'

export const zIndex = system({
  zIndex: {
    property: 'zIndex',
    scale: 'zIndex',
  },
})
